import React, { useState, useEffect } from 'react';
import numWords from 'num-words'; // Library to convert numbers to words
import img from '../../assets/images/updatereport.png'

const UpdatedReport = ({reportDataUpdated  }) => {


    // const location = useLocation();
    // const { reportDataUpdated } = location.state || {};
    const udiseNumber = localStorage.getItem("udiseNumber");
  // Ensure all values are numbers for calculation

  const language = localStorage.getItem("language");
  console.log("reportDataUpdated",reportDataUpdated);
  
    //  const totalPaidFee = reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.beforePay || 0), 0);
    //   const discountAmountTotal = reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.discountAmount || 0), 0);

      const totalPaidFee = Array.isArray(reportDataUpdated.feeDetails) 
      ? reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.beforePay || 0), 0) 
      : 0;
  
  const discountAmountTotal = Array.isArray(reportDataUpdated.feeDetails) 
      ? reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.discountAmount || 0), 0) 
      : 0;
  const [schoolDetails, setSchoolDetails] = useState({});
  const fetchSchoolDetails = async (udiseNumber) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`);
      const data = await response.json();
      return data || {}; // Return the fetched data or an empty object if null
    } catch (error) {
      console.error('Error fetching school details:', error);
      return {};
    }
  };

// if(reportDataUpdated.feeDetails){
//   const date = new Date(reportDataUpdated.feeDetails[0].date) ||  new Date();
// }else{
//   const date = new Date() ;
// }
 

const date = (reportDataUpdated?.feeDetails && reportDataUpdated.feeDetails[0]) 
? new Date(reportDataUpdated.feeDetails[0].date) 
: new Date() ;

// Function to format date to dd-mm-yyyy
const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getBaseFeetype = (feetype) => {
    if (!feetype) return '';
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype; // Return the part before the last '-' or the whole feetype if '-' is not found
  };

  useEffect(() => {
    const fetchSchoolData = async () => {
      if (udiseNumber) {
        const details = await fetchSchoolDetails(udiseNumber);
        setSchoolDetails(details);
      }
    };
    fetchSchoolData();
  }, [udiseNumber]);

  const generateHtmlReport = () => {
    console.log("come");
    
    let totalFeeAmount = 0;
    let totalPaidFee2 = 0;

    const feeDetails = reportDataUpdated?.feeDetails || [];
    const firstFee = feeDetails[0] || {};

    const filteredFeeDetails = feeDetails.filter(fee => fee && parseFloat(fee.amount) > 0);
    const transType = reportDataUpdated?.transaction || firstFee.transaction || '';
    const ddno = reportDataUpdated?.ddNo || firstFee.ddNo || '';
    const dddate = reportDataUpdated?.dddate || firstFee.dddate || '';
    const online = reportDataUpdated?.paymentGatewayType || firstFee.paymentGatewayType || '';
    const transId = reportDataUpdated?.transactionId || firstFee.transactionId || '';
    const checkno = reportDataUpdated?.checkNo || firstFee.checkNo || '';
    const checkdate = reportDataUpdated?.checkDate || firstFee.checkDate || '';

    const feeDetailsRows = filteredFeeDetails.map((fee, index) => {
      console.log("come2");
      console.log("fee",fee);
      console.log("fee.transaction",fee.transaction);
  
      const feeAmount = parseFloat(fee.amount || 0);
      const payAmt = parseFloat(fee.payAmount || 0);
      totalFeeAmount += feeAmount;
      totalPaidFee2 += payAmt;
      console.log("come3");
  
      return `
        <tr>
          <td>${index + 1}</td>
          <td>${getBaseFeetype(fee.feetype)}</td>
          <td>${feeAmount.toFixed(2)}</td>
          <td>${payAmt.toFixed(2)}</td>
        </tr>
      `;
    }).join('');
    console.log("come4");
    console.log("feeDetailsRows",feeDetailsRows);
  
    const totalRemainingAmount = totalFeeAmount - (totalPaidFee2+totalPaidFee) - discountAmountTotal;
    console.log("come5");
    
    // const remainingFeeInWords = numWords(totalRemainingAmount); 
    const isNegative = totalRemainingAmount < 0;
    const absoluteRemainingAmount = Math.abs(totalRemainingAmount);
    
    // Convert to words
    const remainingFeeInWords = isNegative 
      ? `-${numWords(absoluteRemainingAmount)}` 
      : numWords(absoluteRemainingAmount);
  
    console.log("come6");
    const headers = language === 'marathi' 
    ? `<tr>
          <th>क्र.</th>
          <th>फी प्रकार</th>
          <th>फी रक्कम</th>
          <th>दिलेली फी</th>
        </tr>`
    : `<tr>
          <th>Sr. No.</th>
          <th>Fee Type</th>
          <th>Fee Amount</th>
          <th>Paid Fee</th>
        </tr>`;
  
    const htmlContent = ` 
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 0; } 
            .receipt-container { width: 99%; display: flex; justify-content: flex-start; gap: 30px; margin: 0; }

            .receipt { width: 80%; border: 1px solid black; padding: 0px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); box-sizing: border-box; height: 750px; }

            .title { text-align: center; background-color: black; color: white; padding: 5px 0; margin-bottom: 10px; width: 150px; margin-left:170px; border-radius: 4px; }
            
            .details { margin-bottom: 15px;  padding-left:5px;}

            table { width: 100%; border-collapse: collapse; margin-top: 10px; }

            th, td { border-bottom: 1px solid black;  border-right: 1px solid black; border-top: 1px solid black; padding:7px; text-align: left; padding-left:10px;  }
th:last-child, td:last-child {
    border-right: none;
}
            th { background-color: #f2f2f2; }
            
           .signature1 { font-size:14px; position: absolute; bottom:10px; right: 55%; }

              .signature { position: absolute; bottom:10px; right: 50px; font-size:14px;}

       @media print {
              .receipt { page-break-after: always; }
                 .signature1 { font-size:14px; position: absolute; bottom:10px; right: 55%; }
   @page {
          size: A4 landscape;
            margin: 3mm; /* this affects the margin in the printer settings */
          }
                .signature { position: absolute; bottom:10px; right: 50px; font-size:14px;; }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            <div class="receipt">
              <div style="border-bottom: 1px solid black; margin-bottom: 5px; background-color: #F7F7F7; padding: 10px;padding-right:8px;">
                <h6 style="text-align: center; margin: 0;">${schoolDetails.sansthaName || ' '}</h6>
                <h3 style="text-align: center; margin: 0;">${schoolDetails.schoolName || ' '}</h3>
              </div>
                     <div style="border-bottom: 1px solid black; border-top: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 5px; font-size:14px; ">
                <p style="margin: 0;">Invoice No: ${reportDataUpdated?.pavatiNo || ''}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Year: ${reportDataUpdated?.year || ''}&nbsp;&nbsp;&nbsp;&nbsp;Date: ${formatDate(reportDataUpdated?.date)}</p>
              </div>
              <div class="details">
                <h7 style="margin: 0;">Student Name: ${reportDataUpdated?.studentName || ''}</h7>
                <div style="font-size: 14px; margin-top: 5px;">
                  <p style="margin: 0;">Class: ${reportDataUpdated?.studentClass || ''}&nbsp;&nbsp;&nbsp;&nbsp;Division: ${reportDataUpdated?.studentDivision !=='N/A' ? (reportDataUpdated?.studentDivision || '-') : '-'}&nbsp;&nbsp;&nbsp;&nbsp; Register No: ${reportDataUpdated?.registerNo || ''}</p>
                </div>
              </div>
            
              <table style="font-size: 14px;">
                <thead >
                  <tr>
                    <th>Sr. No.</th>
                    <th>Fee Type</th>
                    <th>Fee Amount</th>
                    <th>Paid Fee</th>
                  </tr>
                </thead>
                <tbody>
                  ${feeDetailsRows}
                  <tr>
                    <td colspan="2">Total</td>
                    <td>${totalFeeAmount.toFixed(2)}</td>
                    <td><b>${totalPaidFee2.toFixed(2)}</b></td>
                  </tr>
                  <tr>
                      <td colspan="2" style="margin: 10px;">Total Discount: Rs. ${discountAmountTotal}</td>
                      <td colspan="2">Last Paid Fee: ${totalPaidFee.toFixed(2)}</td>
                  </tr>
                  <tr>
                      <td colspan="2">Transaction By: ${transType}</td>
                    <td colspan="2"><b>Remaining Fee: ${totalRemainingAmount.toFixed(2)}</b></td>
                  </tr>

                   ${ddno || dddate ? `<tr>
                  <td colspan="2">DD Number: ${ddno}</td>
                  <td colspan="2">DD Date: ${formatDate(dddate)}</td>
                  </tr>` : ''}

                   ${online || transId ? `<tr>
                  <td colspan="2">UPI Mode: ${online}</td>
                  <td colspan="2">Trans. ID.: ${transId}</td>
                  </tr>` : ''}

                   ${checkno || checkdate ? `<tr>
                  <td colspan="2">Check Number: ${checkno}</td>
                  <td colspan="2">Check Date: ${formatDate(checkdate)}</td>
                  </tr>` : ''}

                  
                </tbody>
              </table>
              <p style="font-size : 12px;  padding-left:7px;" >Remaining Fee (in words): ${remainingFeeInWords}</p>
              <p class="signature1">Signature</p>
            </div>
  
            <div class="receipt">
              <div style="border-bottom: 1px solid black; margin-bottom: 5px; background-color: #F7F7F7; padding: 10px; padding-right:8px;">
                <h6 style="text-align: center; margin: 0;">${schoolDetails.sansthaName || ' '}</h6>
                <h3 style="text-align: center; margin: 0;">${schoolDetails.schoolName || ' '}</h3>
              </div>
              <div class="title">Student Fee Receipt</div>
              <div style="border-bottom: 1px solid black; border-top: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 5px; font-size:14px;">
                  <p style="margin: 0;">Invoice No: ${reportDataUpdated?.pavatiNo || ''}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Year: ${reportDataUpdated?.year || ''}&nbsp;&nbsp;&nbsp;&nbsp;Date: ${formatDate(reportDataUpdated?.date)}</p>
              </div>
              <div class="details">
                <h7 style="margin: 0;">Student Name: ${reportDataUpdated?.studentName || ''}</h7>
                <div style="font-size: 14px; margin-top: 5px;">
                    <p style="margin: 0;">Class: ${reportDataUpdated?.studentClass || ''}&nbsp;&nbsp;&nbsp;&nbsp; Division: ${reportDataUpdated?.studentDivision !=='N/A' ? (reportDataUpdated?.studentDivision || '-') : '-'}&nbsp;&nbsp;&nbsp;&nbsp; Register No: ${reportDataUpdated?.registerNo || ''}</p>
                </div>
              </div>
              <table style="font-size: 14px;">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Fee Type</th>
                    <th>Fee Amount</th>
                    <th>Paid Fee</th>
                  </tr>
                </thead>
                <tbody>
                  ${feeDetailsRows}
                  <tr>
                    <td colspan="2">Total</td>
                    <td>${totalFeeAmount.toFixed(2)}</td>
                    <td><b>${totalPaidFee2.toFixed(2)}</b></td>
                  </tr>

                  
                   <tr>
                      <td colspan="2" style="margin: 10px;">Total Discount: Rs. ${discountAmountTotal}</td>
                      <td colspan="2">Last Paid Fee: ${totalPaidFee.toFixed(2)}</td>
                  </tr>
                  <tr>
                     <td colspan="2">Transaction By: ${transType}</td>
                    <td colspan="2"><b>Remaining Fee: ${totalRemainingAmount.toFixed(2)}</b></td>
                  </tr>

                  ${ddno || dddate ? `<tr>
                  <td colspan="2">DD Number: ${ddno}</td>
                  <td colspan="2">DD Date: ${formatDate(dddate)}</td>
                  </tr>` : ''}

                   ${online || transId ? `<tr>
                  <td colspan="2">UPI Mode: ${online}</td>
                  <td colspan="2">Trans. ID.: ${transId}</td>
                  </tr>` : ''}

                   ${checkno || checkdate ? `<tr>
                  <td colspan="2">Check Number: ${checkno}</td>
                  <td colspan="2">Check Date: ${formatDate(checkdate)}</td>
                  </tr>` : ''}

                  
                </tbody>
              </table>
              <p  style="font-size : 12px; padding-left:7px;">Remaining Fee (in words): ${remainingFeeInWords}</p>
              <p class="signature">Signature</p>
            </div>
          </div>
        </body>
      </html>
    `;
  
    // Open a new window and write the HTML content
    const newWindow = window.open('', '_blank');
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  
    // Wait for the content to load before triggering the print
    newWindow.focus();
    newWindow.print();
  
    // Optionally close the window after printing
    newWindow.onafterprint = function() {
      newWindow.close();
    };
  };
  
  
  return (
    <div>
    
      <img
        src={img}
        style={{ width: '33px', height: 'auto', cursor: 'pointer', marginBottom:'10px' }}
        onClick={generateHtmlReport}
        title="Quick Receipt"
      />
    </div>
  );
};

export default UpdatedReport;
